import { reducer } from "./reducer"
export const proposalReducer = reducer

export * from "./types"



// WEBPACK FOOTER //
// ./src/state/proposal/reducers/index.ts